import {SortOrder} from "ts-protocol-extension";
import {RouterProps} from "../../RouterProps";
import {useStatePair} from "react-type-extension";
import {UserWithdrawalValueObject} from "../../../data/value-object/user/UserWithdrawalValueObject";
import {UserWithdrawalSearchOption} from "../../../data/search-option/user/UserWithdrawalSearchOption";
import {SearchIndex} from "../../../io/HttpClient";
import ListPageWrapper from "../../ListPageWrapper";
import {UserWithdrawalIO} from "../../../io/UserIO";
import {UserWithdrawalDescription} from "../../../data/description/user/UserWithdrawalDescription";
import {UserWithdrawalDescriptor} from "../../../data/descriptor/user/UserWithdrawalDescriptor";
import ListOption from "../../ListOption";
import {
    UserWithdrawalSearchOptionDescription
} from "../../../data/description/user/UserWithdrawalSearchOptionDescription";
import {
    applyUserWithdrawalSearchOption,
    UserWithdrawalSearchOptionField
} from "../../search-option-field/user/UserWithdrawalSearchOptionField";
import ListOrder from "../../ListOrder";

enum Phase {
    List,
    Option,
    Order
}

export default function List(props: RouterProps) {
    const phase = useStatePair<Phase>(Phase.List)
    const items = useStatePair<UserWithdrawalValueObject[]>([])
    const option = useStatePair<UserWithdrawalSearchOption>({})
    const index = useStatePair<SearchIndex>({ pageIndex: 0n, sortOrder: [SortOrder.ASC], sortPriority: ['id'] })

    return <>
        {phase.value === Phase.List && <>
            <ListPageWrapper
                {...props}
                client={UserWithdrawalIO}
                items={items}
                option={option.value}
                index={index}
                description={UserWithdrawalDescription}
                descriptor={UserWithdrawalDescriptor}
                showFilter
                onFilterClick={() => phase.setter(Phase.Option)}
                showSort
                onSortClick={() => phase.setter(Phase.Order)}
                onItemClick={item => `/users/signIns/${item.id}`}/>
        </>}
        {phase.value === Phase.Option && <>
            <ListOption
                {...props}
                option={option.value}
                description={UserWithdrawalSearchOptionDescription}
                fields={UserWithdrawalSearchOptionField}
                onBackClick={() => phase.setter(Phase.List)}
                onApplyClick={(key, value) => {
                    applyUserWithdrawalSearchOption(key, value, option)
                    index.setter({ ...index.value, pageIndex: 0n })
                    items.setter([])
                }}
                onDismissClick={key => {
                    const next = { ...option.value }
                    next[key] = undefined
                    option.setter(next)
                    items.setter([])
                }} />
        </>}
        {phase.value === Phase.Order && <>
            <ListOrder
                {...props}
                index={index}
                description={UserWithdrawalDescription}
                onBackClick={() => phase.setter(Phase.List)}
                onOrderUpdated={() => items.setter([])} />
        </>}
    </>
}